import Base from "antd/es/config-provider";

type Props = Parameters<typeof Base>[0];
type Theme = NonNullable<Props["theme"]>;

const token: Theme["token"] = {
  colorPrimary: "#076dbf",
  colorLink: "#076dbf",
  borderRadius: 4,
};

const defaults: Props = {
  theme: {
    token,
    components: {
      Layout: {
        headerHeight: 52,
        headerPadding: "0 0 0 18px",
        footerBg: "#2d2d2d",
        footerPadding: 8,
      },
      Form: {
        itemMarginBottom: 12,
      },
      Card: {
        headerFontSize: 22,
        fontSize: 16,
      },
      Descriptions: {
        paddingXS: 4,
      },
    },
  },
};

export default function ConfigProvider(props: Props) {
  return <Base {...defaults} {...props} />;
}
